export const FALLBACK_ROUTE = '/error/notfound';
